<template>
  <Wizard class="tutorial-wizard" :logo=false>
    <a class="close" v-close @click="$close(false)"></a>
    <div
      :is="steps[step-1]"
      @proceed=proceed
    >
      <template v-if="steps && steps.length > 1">
        <PrevNext class="nav" :step=step :steps=steps :pagevalid=pagevalid />
        <button class="arrow next" v-if="step===steps.length" @click="finish"></button>
      </template>
    </div>
  </Wizard>
</template>

<script>
  import Wizard from '@/helpers/components/display/Wizard'
  import steps from '@/helpers/mixins/steps'

  export default {
    name: 'Tutorial',
    mixins: [steps],
    components: {Wizard},
    props: {
      pages: {required: true},
    },
    computed: {
      steps () {
        //Generate steps from pages prop
        return this.pages.map(step => ({
          //<figure><div><img/><clickable-areas/></div><figcaption/></figure>
          render (el) {
            //figure
            return el('figure', {class: 'tutorial-step'}, [
              //div
              el('div', {}, [
                //img
                el('img', {attrs: {src: step.img}})
                //all clickable areas (positioned absolute)
                ].concat((step.areas || []).map(area =>
                  el('a', {
                    class: 'area',
                    on: {click: () => this.$emit('proceed')},
                    style: {
                      left: area.x + '%',
                      top: area.y + '%',
                      width: area.w + '%',
                      'padding-bottom': area.r + '%',
                    },
                  })
                )
              )),
              el('figcaption', {domProps: {innerHTML: step.trans ? this.$t(step.trans) : ''}}),
              //previous/next buttons (in slot)
              this.$slots.default,
            ]);
          }
        }));
      },
      pageerrors () {
        return new Array(this.pages.length).fill([]);
      },
    },
    methods: {
      proceed () {
        if (this.step < this.steps.length) {
          this.step++;
        } else {
          this.finish();
        }
      },
      finish () {
        this.$close(1);
      },
      preloadImages () {
        this.pages.map(step => {
          if (step.img) {
            new Image().src = step.img;
          }
        });
      },
    },
    mounted () {this.preloadImages();},
    watch: {
      steps () {this.preloadImages();}
    },
  }
</script>

<style lang="scss">
  div.wizard.tutorial-wizard {
    .contents {
      width: 1168px;
      padding: 0;
      figure.tutorial-step {
        > div {
          position: relative;
          img, object {
            width: 100%;
          }
          a.area {
            display: block;
            position: absolute;
            cursor: pointer;
          }
        }
        > figcaption {
          background: $accent;
          min-height: 182px;
          color: white;
          @include font-size(26px, 40px);
          padding: 40px 20px;
          @media (min-width: $sm-min) {
            padding-left: 80px;
            padding-right: 80px;
          }
        }
        > nav {
          .btn {
            display: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/interact/Tutorial.vue